var SlideOutMenu = (function () {
    'use strict';
    var conf;
    var moment = require('moment');
    var utils = require('./utils');
    var avyaktMurliDates = [];

    function menuClose() {
        // create menu variables
        var slideoutMenu = $('.slideout-menu');
        var slideoutMenuWidth = slideoutMenu.width();
        // toggle open class
        slideoutMenu.removeClass("open");
        slideoutMenu.animate({
            right: -slideoutMenuWidth
        }, 320);
    }

    function loadMetaData(conf) {
        fetch(conf.baseUrl + "/murlis/" + conf.lang + "/season-murli-list.json").then(function (response) {
            return response.json();
            // TODO: in case of /#error remove menu options
        }).then(function (body) {
            generateAvyaktMenu(body.reverse());
            $(".slideout-menu").trigger('avyaktlistready', [conf, avyaktMurliDates]);
        }).catch(function (err) {
            console.log('Error fetching metadata. ' + err);
            $("#seasonalMurliList").empty();
            $(".slideout-menu").trigger('avyaktlistready', [conf, []]);
        });
    }

    function generateAvyaktMenu(years) {
        var app = require('./murli');
        $("#seasonalMurliList").empty();
        $.each(years, function (y) {
            var html = '<li id="year-' + years[y].year + '" class="submenuItems toggle"><a class="year-item" href="#"><i class="icon-calendar"></i> ' + years[y].year + '</a><ul class="subMenuList">';
            $.each(years[y].months, function (m) {
                //html += '<li class="submenuItems toggle"><a class="month-item" href="#">' + years[y].months[m].month + '</a><ul class="subMenuList">';
                $.each(years[y].months[m].days, function (d) {
                    var id = y + '-' + m + '-' + d;
                    avyaktMurliDates.push(years[y].months[m].days[d]);
                    html += '<li><a id="day-item-' + id + '" href="#">' + moment(years[y].months[m].days[d]).format("MMM Do YYYY") + '</a></li>';
                });
                //html += '</ul></li>';
            });
            html += '</ul></li>'
            $("#seasonalMurliList").append(html);
        });
        $.each(years, function (y) {
            $.each(years[y].months, function (m) {
                $.each(years[y].months[m].days, function (d) {
                    var id = y + '-' + m + '-' + d;
                    $("#day-item-" + id).click(function () {
                        conf.cat = "season";
                        app.moveToDate(conf, moment(years[y].months[m].days[d]));
                        $("#murli-type>span").text("Season Avyakt");
                        menuClose();
                        window.gaU('send', 'event', { 'eventCategory': 'Navigation', 'eventAction': 'click', 'eventLabel': conf.cat + '/' + conf.lang + '/' + years[y].months[m].days[d] });
                    });
                });
            });
        });
    }

    function init(config) {
        var app = require('./murli');
        conf = config;
        loadMetaData(conf);

        $(function () {
            var $date = $('.docs-date');
            var options = {
                endDate: new Date(conf.today.clone().add(2, 'days').toDate()),
                autoShow: true,
                startDate: new Date(2017, 0, 1),
                inline: true,
                container: '#pastMurliListItem1',
                language: 'en-GB',
                offset: 0,
                weekStart: 1,
                startView: 0
            };
            $date.on({
                'pick.datepicker': function (e) {
                    conf.cat = "daily";
                    app.moveToDate(conf, moment(e.date));
                    menuClose();
                }
            }).datepicker(options);
        });

        $('.slideout-menu-toggle').on('click', function (e) {
            e.preventDefault();
            // create menu variables
            var slideoutMenu = $('.slideout-menu');
            var slideoutMenuWidth = $('.slideout-menu').width();
            // toggle open class
            slideoutMenu.toggleClass("open");
            // slide menu
            if (slideoutMenu.hasClass("open")) {
                slideoutMenu.animate({
                    right: "0px"
                });
            } else {
                slideoutMenu.animate({
                    right: -slideoutMenuWidth
                }, 320);
            }
            e.stopImmediatePropagation();
        });

        $("#dailyMenuItem").click(function (event) {
            conf.cat = "daily";
            app.moveToDate(conf, conf.today);
            $("#murli-type>span").text("Daily Murli");
            window.gaU('send', 'event', { 'eventCategory': 'Navigation', 'eventAction': 'click', 'eventLabel': conf.cat + '/' + conf.lang + '/' + conf.today.format('YYYY-MM-DD') });
            menuClose();
        });

        $(document).on("click", ".daily-item", function (e) {
            $(this).parent().children("ul:first-of-type").slideToggle(300);
            $(this).parent().toggleClass("toggled toggle");
            e.stopImmediatePropagation();
        }).on("click", ".past-murli-item", function (e) {
            $(this).parent().children("ul:first-of-type").slideToggle(300);
            $(this).parent().toggleClass("toggled toggle");
            e.stopImmediatePropagation();
        });

        $(document).on("click", ".seasonal-item", function (e) {
            $(this).parent().children("ul:first-of-type").slideToggle(300);
            $(this).parent().toggleClass("toggled toggle");
            e.stopImmediatePropagation();
        }).on("click", ".year-item", function (e) {
            $(this).parent().children("ul").slideToggle(300);
            $(this).parent().toggleClass("toggled toggle");
            e.stopImmediatePropagation();
        }).on("click", ".month-item", function (e) {
            $(this).parent().children("ul").slideToggle(300);
            $(this).parent().toggleClass("toggled toggle");
            e.stopImmediatePropagation();
        });

        $("#refreshBtn").click(function (e) {
            location.reload();
            menuClose();
        });

        $("#themeLnk").click(function (e) {
            $("#themeCbx").click();
            //$("#themeCbx").prop('checked', !$("#themeCbx").prop("checked"))
        });

        $("#themeCbx").change(function (e) {
            if ($(this).prop('checked')) {
                $('head').append('<link title="dark-theme" rel="stylesheet" href="themes/dark.css" type="text/css" />');
                localStorage.setItem("murli.darkTheme", true);
            }
            else {
                localStorage.removeItem("murli.darkTheme");
                $('link[title=dark-theme]').prop('disabled', true);
            }
        });

        $("#feedbackBtn").click(function (e) {
            menuClose();
            Userback.open("form");
        });

        $('#refresh-menu-item').hide();
        $('#download-menu-item').show();
    }

    return {
        menuClose: menuClose,
        init: init
    }
}());

module.exports = SlideOutMenu;
